import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, Inject, inject, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Store } from '@ngrx/store';
import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { SafeAny } from '../../../../types/safe-any';
import { selectOrdersError } from '../../../../@store/orders/orders.selectors';

@Component({
  selector: 'ciwc-archive-order-dialog',
  standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './archive-order-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArchiveOrderDialogComponent {
  private readonly store = inject(Store);
  readonly error = this.store.selectSignal(selectOrdersError);
  readonly lastAction = this.store.selectSignal(state => state.orders.lastAction);
  isArchiving = signal(false);

  constructor(
    public dialogRef: MatDialogRef<ArchiveOrderDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { order: SafeAny; isArchived: boolean },
  ) {
    effect(() => {
      if (this.isArchiving()) {
        const error = this.error();
        if (error) {
          this.isArchiving.set(false);
        }
      }
    });

    effect(() => {
      const action = this.lastAction();
      if (action === 'Archive Order Success' && this.isArchiving()) {
        this.isArchiving.set(false);
        this.dialogRef.close({
          success: true,
          isArchived: !this.data.isArchived
        });
      }
    });
  }

  onCancel(): void {
    this.dialogRef.close();
  }

  onConfirm(): void {
    this.isArchiving.set(true);
    this.store.dispatch(OrdersActions.archiveOrder({
      orderId: this.data.order.id,
      isArchived: this.data.isArchived
    }));
  }
}
